import { Model } from "@game.object/ts-game-toolbox/dist/src/abstract/mvc/Model";
import { BlockModel } from "./BlockModel";
import { ModelCollection } from "./ModelCollection";

export class BlockChainModel extends Model<ModelCollection> {
    public block_ids: Array<number> = [];
    public computing_block_index = 0;
    public is_computing: boolean = false;


    public select(start: number, end: number) {
        this.is_computing = false;
        this.block_ids = [];
        for (let i = start; i <= end; i++) {
            this.block_ids.push(i);
        }
    }

    public request_compute() {
        this.is_computing = true;
        this.computing_block_index = 0;
        let previous_hash = 0;
        this.block_ids.forEach((id) => {
            const block = this.models.blocks.where('id', id).pop();
            if (block) {
                block.previous_hash = previous_hash;
                previous_hash = block.hash;
                block.hash = block.compute_hash();
            }
        });
        const block = this.compute_get_active_block();
        if (block) this.compute_block(0, block);
    }

    public compute() {
        const block = this.compute_get_active_block();
        if (!block) {
            this.is_computing = false;
            return;
        }
        if (block.is_valid) {
            this.compute_next_block(block);
            return;
        }
    }

    private compute_get_active_block(): BlockModel | null {
        if (this.computing_block_index >= this.block_ids.length) {
            return null;
        }
        const computing_block_id = this.block_ids[this.computing_block_index];
        const block = this.models.blocks.where('id', computing_block_id).pop();
        return block || null;
    }

    private compute_next_block(previous_block: BlockModel) {
        this.computing_block_index++;
        const block = this.compute_get_active_block();
        if (block) {
            this.compute_block(previous_block.hash, block);
        } else {
            this.is_computing = false;
        }
    }

    private compute_block(previous_hash: number, block: BlockModel) {
        block.previous_hash = previous_hash;
        block.mine();
    }
}